"use client";
import { useHologramActions } from "@/contexts/HologramContext";

const ChangeHologram = ({
  hologram = 0,
  children,
}: {
  hologram: number;
  children: React.ReactNode;
}) => {
  const { changeHologram, revertHologram } = useHologramActions();

  return (
    <>
      <div
        onMouseEnter={() => {
          changeHologram(hologram);
        }}
        onMouseLeave={() => {
          revertHologram();
        }}>
        {children}
      </div>
    </>
  );
};

ChangeHologram.displayName = "ChangeHologram";

export default ChangeHologram;
